import { render, staticRenderFns } from "./Featuresd.vue?vue&type=template&id=558c67d6&"
import script from "./Featuresd.vue?vue&type=script&lang=js&"
export * from "./Featuresd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports